import React from "react";
import "./airport.css";
import { Link } from "react-router-dom";  
import { FaCar, FaUserTie, FaShieldAlt, FaClock, FaMapMarkerAlt, FaEnvelope, FaPhone, FaWhatsapp, FaStar } from "react-icons/fa";

function AirportPickupDrop() {
  return (
    <section className="tour4-container">

              <div className="banner">
          <img 
            src="/airport-transfer.jpg" 
            alt="Airport Pickup and Drop Banner" 
            className="banner-image" 
          />
        </div>
      {/* Title */}
      <h1 className="tour4-title">Premium Airport Transfer Services in Sri Lanka</h1>

      <div className="tour4-layout">
        {/* Left Section */}
        <div className="tour4-left">
          {/* Info Boxes */}
          <div className="tour4-info-cards">
            <div className="info-card">
              <FaCar className="info-icon" />
              <div>
                <h4>Vehicle Types</h4>
                <p>Sedan, Van, Luxury</p>
              </div>
            </div>

            <div className="info-card">
              <FaUserTie className="info-icon" />
              <div>
                <h4>Professional Drivers</h4>
                <p>Multi-Lingual Guides</p>
              </div>
            </div>

            <div className="info-card">
              <FaShieldAlt className="info-icon" />
              <div>
                <h4>Safety First</h4>
                <p>Fully Insured</p>
              </div>
            </div>

            <div className="info-card">
              <FaClock className="info-icon" />
              <div>
                <h4>24/7 Service</h4>
                <p>Always Available</p>
              </div>
            </div>
          </div>

          {/* Service Highlights */}
          <div className="tour4-highlights">
            <h3>Why Choose Our Airport Transfer Service?</h3>
            <p>
              Experience unparalleled comfort and reliability with Eco Rich Travels. 
              We specialize in making your journey through Sri Lanka absolutely seamless 
              from the moment you land until your departure.
            </p>

            <div className="tour4-galleryt">
              <img src="/banner-airport-1.jpg" alt="Airport Transfer" />
              {/* <img src="/luxury-vehicles.jpg" alt="Luxury Vehicles" />
              <img src="/professional-driver.jpg" alt="Professional Driver" />
              <img src="/airport-greeting.jpg" alt="Airport Greeting" />
              <img src="/comfortable-ride.jpg" alt="Comfortable Ride" />
              <img src="/safety-first.jpg" alt="Safety First" />
              <img src="/luggage-assistance.jpg" alt="Luggage Assistance" />
              <img src="/sri-lanka-scenery.jpg" alt="Sri Lanka Scenery" />
              <img src="/customer-service.jpg" alt="Customer Service" /> */}
            </div>
          </div>

          {/* Service Details */}
          <div className="tour4-itinerary">
            <h3>Seamless Airport Transfers</h3>
            <ul>
              <li>Meet & Greet Service at Bandaranaike International Airport</li>
              <li>Comprehensive Transportation Solutions:</li>
              <ul>
                <li><strong>Private Transfers:</strong> Exclusive vehicles for your group</li>
                <li><strong>Shared Rides:</strong> Cost-effective options for solo travelers</li>
                <li><strong>Luxury Transfers:</strong> Premium vehicles for special occasions</li>
                <li><strong>Group Transfers:</strong> Spacious vans for families and groups</li>
              </ul>
              <li>Flight Monitoring for Delayed Arrivals</li>
              <li>Complimentary Waiting Time</li>
              <li>Luggage Assistance Included</li>
            </ul>

            <h3>Professional Driver-Guides</h3>
            <ul>
              <li>Certified and Experienced Professionals</li>
              <li>Multi-Lingual Capabilities (English, Sinhala, Tamil)</li>
              <li>Extensive Local Knowledge</li>
              <li>Services Include:</li>
              <ul>
                <li>Cultural and Historical Insights</li>
                <li>Local Recommendations and Hidden Gems</li>
                <li>Navigation through Best Routes</li>
                <li>Assistance with Local Arrangements</li>
              </ul>
              <li>Safety-Conscious Driving Practices</li>
            </ul>

            <h3>Our Vehicle Fleet</h3>
            <ul>
              <li>Modern, Well-Maintained Vehicles</li>
              <li>Regular Safety Inspections and Maintenance</li>
              <li>Comprehensive Insurance Coverage</li>
              <li>Vehicle Categories:</li>
              <ul>
                <li><strong>Economy Sedans:</strong> Comfortable for 1-3 passengers</li>
                <li><strong>Luxury Cars:</strong> Premium comfort for business travelers</li>
                <li><strong>Family Vans:</strong> Spacious for 4-8 passengers</li>
                <li><strong>Luxury Vans:</strong> Executive travel for larger groups</li>
              </ul>
              <li>Child Seats Available Upon Request</li>
            </ul>

            <h3>Service Coverage Areas</h3>
            <ul>
              <li>Bandaranaike International Airport (CMB)</li>
              <li>Mattala Rajapaksa International Airport (HRI)</li>
              <li>All Major Cities and Tourist Destinations:</li>
              <ul>
                <li>Colombo and Greater Colombo Area</li>
                <li>Popular Beach Destinations: Negombo, Bentota, Hikkaduwa, Mirissa</li>
                <li>Cultural Triangle: Kandy, Dambulla, Sigiriya, Anuradhapura</li>
                <li>Hill Country: Nuwara Eliya, Ella, Hatton</li>
                <li>Wildlife Parks: Yala, Udawalawe, Wilpattu</li>
              </ul>
              <li>Hotel Transfers Nationwide</li>
            </ul>
          </div>
        </div>

        {/* Right Sidebar */}
        <aside className="tour4-sidebar">
          <div className="sidebar-box">
            <h3>BOOK YOUR TRANSFER</h3>
            <p>
              Ready for a stress-free journey in Sri Lanka? Book your airport transfer 
              with <strong>Eco Rich Travels</strong> and experience premium transportation services.
            </p>
            <Link to="/bookings" style={{ textDecoration: 'none' }}>
              <button className="btn-primary">BOOK TRANSFER</button>
            </Link>
         
                                 <button 
            className="btn-secondary"
            onClick={() => window.open(`https://wa.me/94742947134`, '_blank')}
          >
            Instant Quote
          </button>
          
          </div>

          <div className="sidebar-box contact-box">
            <h3>GET IN TOUCH</h3>
            <p>
              Have questions about our services? Need a custom quote? 
              Contact us directly for personalized assistance.
            </p>

            <div className="contact-details">
              <p><FaEnvelope /> info@ecorichtravels.com</p>
              <p><FaPhone /> +94 74 294 7134</p>
              <p><FaWhatsapp /> +94 74 294 7134</p>
              <p><FaMapMarkerAlt /> 520, Pamunugama Rd, Negombo</p>
            </div>
          </div>

          <div className="sidebar-box">
            <h3>WHY CHOOSE US?</h3>
            <div className="contact-details">
              <p><FaStar /> Punctual & Reliable Service</p>
              <p><FaStar /> Professional Multi-Lingual Drivers</p>
              <p><FaStar /> Modern, Well-Maintained Fleet</p>
              <p><FaStar /> 24/7 Customer Support</p>
              <p><FaStar /> Competitive Pricing</p>
              <p><FaStar /> Full Insurance Coverage</p>
            </div>
          </div>
        </aside>
      </div>

      {/* Booking Form Section */}
      {/* <div className="tour4-itinerary" style={{marginTop: '40px'}}>
        <h3>Quick Booking Request</h3>
        <form className="booking-form">
          <div className="form-row">
            <div className="form-group">
              <label>First Name</label>
              <input type="text" placeholder="Enter your first name" required />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input type="text" placeholder="Enter your last name" required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Country</label>
              <input type="text" placeholder="Your country of residence" required />
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input type="tel" placeholder="Contact number with country code" required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" placeholder="Your email address" required />
            </div>
            <div className="form-group">
              <label>Arrival Date</label>
              <input type="date" required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Arrival Time</label>
              <input type="time" required />
            </div>
            <div className="form-group">
              <label>Number of Passengers</label>
              <select required>
                <option value="">Select passengers</option>
                <option value="1">1 Passenger</option>
                <option value="2">2 Passengers</option>
                <option value="3">3 Passengers</option>
                <option value="4">4 Passengers</option>
                <option value="5+">5+ Passengers</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <label>Special Requirements</label>
              <textarea 
                placeholder="Flight number, pickup location, destination, special requests (child seats, extra luggage, etc.)..." 
                rows="4"
              ></textarea>
            </div>
          </div>

          <button type="submit" className="btn-primary" style={{marginTop: '20px'}}>
            SEND TRANSFER REQUEST
          </button>
        </form>
      </div> */}
    </section>
  );
}

export default AirportPickupDrop;